import React, { forwardRef } from 'react';
import { DialogBackdrop, DialogBackdropProps } from 'reakit';
import styled from 'styled-components';

const StyledBackdrop = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(118deg, rgba(74, 9, 0, 0.6) 0%, rgba(2, 0, 77, 0.6) 100%);
    overflow-y: auto;
    z-index: 999;
`;

export interface BackdropProps {
    children: React.ReactNode;
}

type PrivateBackdropProps = BackdropProps & DialogBackdropProps;

export const Backdrop = forwardRef<HTMLDivElement, PrivateBackdropProps>(function (props, ref) {
    return <DialogBackdrop ref={ref} as={StyledBackdrop} {...props} />;
});
